import { Popover as Primitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.ts';

/**
 * A Radix Popover on the design system's v2 Dropdown surface (the same panel Select and the
 * dropdown menus use). Radix closes it on Escape and outside click; `collisionPadding` keeps
 * it on screen on a narrow viewport.
 */
export const Popover = Primitive.Root;
export const PopoverTrigger = Primitive.Trigger;
export const PopoverAnchor = Primitive.Anchor;

export function PopoverContent({
  className,
  align = 'start',
  sideOffset = 4,
  collisionPadding = 16,
  ...props
}: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Content
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          'ds-v2 animate-pop-in z-50 max-h-(--radix-popover-content-available-height) max-w-[calc(100vw-2rem)] overflow-auto rounded-[12px] border border-(--v2-dropdown-border) bg-(--v2-dropdown-bg) p-3 text-(--v2-dropdown-text) shadow-(--v2-dropdown-shadow) outline-none',
          className,
        )}
        {...props}
      />
    </Primitive.Portal>
  );
}
